import { ManualSeatPickerAction } from './actions';

export interface IManualSeatPicker {
  isFetchingSections: boolean;
  isFetchingInnerSection: boolean;
  isFetchingCurrentReservations: boolean;
  isFetchSectionsFailed: boolean;
  isFetchInnerSectionFailed: boolean;
  isFetchCurrentReservationFailed: boolean;
  isReservationSuccessful: boolean;
  nbrOfReservationsOnFetch: number,
  sections: Julius.Website.SectionViewModel[];
  innerSection: Julius.Website.InnerSectionViewModel;
  priceCategories: Julius.Website.PriceCategoryViewModel[];
  reservationErrors: string[];
  selectedSeats: Julius.Website.OrderSeatViewModel[];
  hoveredSeats: Julius.Website.SectionSeatViewModel[];
  isFetchingReservations: boolean;
}

const initialManualSeatPicker: IManualSeatPicker = {
  isFetchingSections: false,
  isFetchingInnerSection: false,
  isFetchSectionsFailed: false,
  isFetchingCurrentReservations: false,
  isFetchInnerSectionFailed: false,
  isFetchCurrentReservationFailed: false,
  isReservationSuccessful: true,
  nbrOfReservationsOnFetch: 0,
  sections: null,
  innerSection: null,
  priceCategories: [],
  reservationErrors: [],
  selectedSeats: [],
  hoveredSeats: [],
  isFetchingReservations: false,
};

function manualSeatPicker(
  state: IManualSeatPicker = initialManualSeatPicker,
  action: ManualSeatPickerAction,
): IManualSeatPicker {

  switch (action.type) {
    case 'SET_IS_FETCHING_SECTIONS':
      return {
        ...state,
        isFetchingSections: true,
      };

    case 'SET_IS_FETCHING_INNER_SECTION':
      return {
        ...state,
        isFetchingInnerSection: true,
      };

    case 'SET_IS_FETCHING_CURRENT_RESERVATIONS':
      return {
        ...state,
        isFetchingCurrentReservations: true,
        isFetchCurrentReservationFailed: false,
        isReservationSuccessful: true,
      };

    case 'INCREASE_RESERVATIONS_ON_FETCH':
      return {
        ...state,
        nbrOfReservationsOnFetch: state.nbrOfReservationsOnFetch + action.toAdd,
      };

    case 'DECREASE_RESERVATIONS_ON_FETCH':
      return {
        ...state,
        nbrOfReservationsOnFetch: state.nbrOfReservationsOnFetch - action.toRemove,
      };

    case 'SET_FETCH_SECTIONS_FAILED':
      return {
        ...state,
        isFetchingSections: false,
        isFetchSectionsFailed: true,
      };

    case 'SET_FETCH_INNER_SECTION_FAILED':
      return {
        ...state,
        isFetchingInnerSection: false,
        isFetchInnerSectionFailed: true,
      };  

    case 'SET_FETCH_CURRENT_RESERVATIONS_FAILED':
      return {
        ...state,
        isFetchingCurrentReservations: false,
        isFetchCurrentReservationFailed: true,
      };

    case 'SET_SECTION_OVERVIEW':
      return {
        ...state,
        isFetchingSections: false,
        isFetchSectionsFailed: false,
        sections: action.sectionOverview.sections,
        priceCategories: action.sectionOverview.priceCategories,
      };

    case 'SET_INNER_SECTION':
      return {
        ...state,
        isFetchingInnerSection: false,
        isFetchInnerSectionFailed: false,
        innerSection: action.innerSection,
      };

    case 'SET_CURRENT_RESERVATION_RESULT':
      return {
        ...state,
        selectedSeats: action.result.reservationSeats,
        reservationErrors: action.result.errors,
        isFetchingCurrentReservations: false,
        isFetchCurrentReservationFailed: false,
      };

    case 'SET_RESERVATION_FAILED':
      return {
        ...state,
        isReservationSuccessful: false,
      };

    case 'ADD_SELECTED_SEAT':
      return {
        ...state,
        selectedSeats: state.selectedSeats.concat(action.seat),
      };

    case 'REMOVE_SELECTED_SEAT':
      return {
        ...state,
        selectedSeats: state.selectedSeats.filter(s => s.seatID !== action.seat.seatID),
      };

    case 'SET_SELECTED_SEATS':
      return {
        ...state,
        selectedSeats: action.seats,
      };

    case 'APPEND_HOVERED_SEAT':
      return {
        ...state,
        hoveredSeats: action.seats,
      }

    case 'CLEAR_HOVERED_SEATS':
      return {
        ...state,
        hoveredSeats: [],
      };

    case 'CLEAR_CONTENT':
      return initialManualSeatPicker;
    
    case 'SET_IS_FETCHING_RESERVATIONS':
      return {
        ...state,
        isFetchingReservations: action.value,
      };
    
    default: return state;
  }
}

export default manualSeatPicker;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/Redux/reducer.tsx